export const baseUrl = process.env.REACT_APP_BASE_URL || "";
export const frontendUrl = process.env.REACT_APP_FRONTEND_URL;
export const culqiPublicToken = null;
export const culqiPrivateToken = null;
export const apiperuToken = process.env.REACT_APP_APIPERU_TOKEN;
export const captchaToken = "6LcHgaorAAAAAJrj5Pa7QEfFt-OMWwbzML3DOJvJ";
export const geolocationToken = process.env.REACT_APP_GEOLOCATION_TOKEN;

export * from "./main";
export * from "./selection";
